// @flow

// Types
import type {
  Recommendation,
} from 'hfty-model-recommendations/types'

import {
  PROP_ASSET,
} from 'hfty-model-recommendations'

// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Selectors
import { recommendations$ } from 'hfty-recommendations'
import recommendationField$ from './recommendationField'

export default createSelector(
  [recommendations$, recommendationField$],
  function (recommendations: Array<Recommendation>, fieldId: ?number): Array<Recommendation> {
    return _filter(recommendations, function (recommendation: Recommendation): boolean {
      return fieldId && recommendation[PROP_ASSET] === fieldId
    })
  }
)
